/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchTransaction = /* GraphQL */ `
  query SearchTransaction(
    $filter: String
    $sort: String
    $limit: Int
    $nextToken: String
  ) {
    searchTransaction(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        IssuedTo
        ClientId
        Invoice
        Published
        TransactionDate
        PurchaseDate
        PedType
        GroupID
        ExpiresAt
        updatedAt
        createdAt
        PDF {
          bucket
          region
          key
        }
        Transaction {
          Product
          ItemId
          Strength
          DoseForm
          ContainerSize
          LotId
          LotExp
          Quantity
        }
        Manufacturer {
          Name
          Address
          City
          State
          Zip
          BulkLotId
          Exp
          ContainerSize
          NDC
          Invoice
          TransactionDate
        }
        Distributors {
          Invoice
          TransactionDate
          Name
          Address
          City
          State
          Zip
        }
      }
      nextToken
    }
  }
`;
export const getPedigree = /* GraphQL */ `
  query GetPedigree($id: ID!) {
    getPedigree(id: $id) {
      id
      IssuedTo
      ClientId
      Invoice
      Published
      TransactionDate
      PurchaseDate
      PedType
      GroupID
      ExpiresAt
      updatedAt
      createdAt
      PDF {
        bucket
        region
        key
      }
      Transaction {
        Product
        ItemId
        Strength
        DoseForm
        ContainerSize
        LotId
        LotExp
        Quantity
      }
      Manufacturer {
        Name
        Address
        City
        State
        Zip
        BulkLotId
        Exp
        ContainerSize
        NDC
        Invoice
        TransactionDate
      }
      Distributors {
        Invoice
        TransactionDate
        Name
        Address
        City
        State
        Zip
      }
    }
  }
`;
export const listPedigrees = /* GraphQL */ `
  query ListPedigrees(
    $filter: ModelPedigreeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPedigrees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        IssuedTo
        ClientId
        Invoice
        Published
        TransactionDate
        PurchaseDate
        PedType
        GroupID
        ExpiresAt
        updatedAt
        createdAt
        PDF {
          bucket
          region
          key
        }
        Transaction {
          Product
          ItemId
          Strength
          DoseForm
          ContainerSize
          LotId
          LotExp
          Quantity
        }
        Manufacturer {
          Name
          Address
          City
          State
          Zip
          BulkLotId
          Exp
          ContainerSize
          NDC
          Invoice
          TransactionDate
        }
        Distributors {
          Invoice
          TransactionDate
          Name
          Address
          City
          State
          Zip
        }
      }
      nextToken
    }
  }
`;
export const pedigreeByDate = /* GraphQL */ `
  query PedigreeByDate(
    $PedType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPedigreeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pedigreeByDate(
      PedType: $PedType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        IssuedTo
        ClientId
        Invoice
        Published
        TransactionDate
        PurchaseDate
        PedType
        GroupID
        ExpiresAt
        updatedAt
        createdAt
        PDF {
          bucket
          region
          key
        }
        Transaction {
          Product
          ItemId
          Strength
          DoseForm
          ContainerSize
          LotId
          LotExp
          Quantity
        }
        Manufacturer {
          Name
          Address
          City
          State
          Zip
          BulkLotId
          Exp
          ContainerSize
          NDC
          Invoice
          TransactionDate
        }
        Distributors {
          Invoice
          TransactionDate
          Name
          Address
          City
          State
          Zip
        }
      }
      nextToken
    }
  }
`;
export const searchPedigrees = /* GraphQL */ `
  query SearchPedigrees(
    $filter: SearchablePedigreeFilterInput
    $sort: SearchablePedigreeSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPedigrees(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        IssuedTo
        ClientId
        Invoice
        Published
        TransactionDate
        PurchaseDate
        PedType
        GroupID
        ExpiresAt
        updatedAt
        createdAt
        PDF {
          bucket
          region
          key
        }
        Transaction {
          Product
          ItemId
          Strength
          DoseForm
          ContainerSize
          LotId
          LotExp
          Quantity
        }
        Manufacturer {
          Name
          Address
          City
          State
          Zip
          BulkLotId
          Exp
          ContainerSize
          NDC
          Invoice
          TransactionDate
        }
        Distributors {
          Invoice
          TransactionDate
          Name
          Address
          City
          State
          Zip
        }
      }
      nextToken
      total
    }
  }
`;
